import { type FunctionComponent, type PropsWithChildren, type ReactNode } from 'react';
import cn from 'classnames';
import { PageHead, type PageHeadProps, VStack } from '@direct-frontend/components';
import styles from './SettingsPageLayout.module.css';

type SettingsPageLayoutProps = PropsWithChildren<{
    title: string | ReactNode;
    caption?: ReactNode;
    pageHeadProps?: PageHeadProps;
    rootClassName?: string;
}>;

export const SettingsPageLayout: FunctionComponent<SettingsPageLayoutProps> = ({
    title,
    caption,
    children,
    pageHeadProps = {},
    rootClassName = '',
}) => (
    <VStack gap="8" className={cn(styles.root, rootClassName)}>
        <PageHead {...pageHeadProps} title={title} caption={caption} />
        {children}
    </VStack>
);
